import clsx from 'clsx';
import { Input } from '../../common';
import { SearchIcon } from '../../common/all-icons/custom-icons';
import styles from './Search.module.scss';

const Search = ({
  placeholder,
  style,
  value,
  onChange,
  iconStyles = {},
  size = 'large',
  fontClass = 'body-medium',
  ...props
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <SearchIcon style={{ position: 'absolute', top: '13px', left: '16px', zIndex: 9, ...iconStyles }} />
      <Input
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={onChange}
        style={style}
        className={clsx(fontClass, styles.searchInput)}
        size={size}
        {...props}
      />
    </div>
  );
};

export default Search;
